import gql from "graphql-tag";
import { orderCommonFragment } from "../fragments/orderCommon";

export default gql`
    mutation sendOrderMutation($orderId: ID!, $language: String! = "en") {
        sendOrder(input: {
            orderId: $orderId
        }) {
            order {
                ...OrderCommon
            }
        }
    }
    ${orderCommonFragment}
`;
